import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import authStore from "../../stores/authStore";

export default function PhoneAuthLogin() {
  const navigate = useNavigate();
  const store = authStore();

  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState('phoneForm'); // 'phoneForm' | 'codeForm'
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const sendCode = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      console.log("Sending the phone #: ", phone);
      await axios.post('/send-otp', { phone });
      setStep('code');

    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong');

    } finally {
      setLoading(false);
    }
  };

  const verifyCode = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
     
      const { data } = await axios.post('/loginWithPhone', { phone, code });

       // Sync the store with the new cookie before leaving this page
      await store.checkAuth();
      navigate("/", { replace: true });

    } catch (err) {
        setError(err.response?.data?.message || 'Something went wrong');
    } finally { 
        setLoading(false);
    }
  };

  return step === "phoneForm" ? (
   <form onSubmit={sendCode}>
      <label>Phone Number</label>
      <input
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />
      <button disabled={loading}>Send code</button>
      {error && <p>{error}</p>}
    </form>
  ) : ( 
    <form onSubmit={verifyCode}>
        <p>Enter the code we sent to {phone}</p>
        <input
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder="6-digit code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <button disabled={loading}>Log in</button>
        {/* <button type="button" onClick={() => { setStep('phoneForm'); setCode(''); }}>
          back
        </button> */}
        {error && <p>{error}</p>}
    </form>
    
  );
}